import { AppUtil, StringUtil } from 'kuaidong-lib'
import { Clazz, ITzyStudentUser, Student, ITzyUser } from 'kuaidong-model'
/**
 * 体智云学生端的请求基类
 */
export class ABaseTzyStudentAPI {
  public static currentUser: ITzyStudentUser | null = null

  public static async httpGET(path: string, params = {}): Promise<any> {
    return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${path}`, params)
  }

  public static async httpPOST(path: string, params = {}): Promise<any> {
    return AppUtil.httpPOST(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${path}`, params)
  }

  public static async httpDELETE(path: string, params = {}): Promise<any> {
    return AppUtil.httpDelete(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${path}`, params)
  }

  public static async httpPUT(path: string, params = {}): Promise<any> {
    return AppUtil.httpPUT(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}${path}`, params)
  }

  // 当前登录的体智云学生端用户基本信息
  public static async findUser(): Promise<ITzyStudentUser | null> {
    try {
      if (this.currentUser) return this.currentUser
      const result = await this.httpGET('/web/school_management/user_info')
      this.currentUser = result
      return result
    } catch (e) {
      console.error(e)
      return null
    }
  }

  public static async findUserWithTeacher(): Promise<ITzyUser | null> {
    try {
      const result = await this.httpGET('/student/user_info')
      return result
    } catch (e) {
      console.error(e)
      return null
    }
  }

  public static async getLoginUserId(): Promise<string> {
    if (!this.currentUser) {
      await this.findUser()
    }
    return this.currentUser ? this.currentUser.student_vo.user_id : ''
  }

  /**
   * 构建参数生成分享用等加密参数
   * @param params 参数
   * @returns string
   */
  public static async buildEncodeParams(params: any): Promise<string> {
    return this.httpPOST('/web/encode_params', { data: JSON.stringify(params) })
  }

  public static async buildWeappURLLink(path: string, query: { [index: string]: string } = {}): Promise<string> {
    const weappUrl =
      path +
      '?' +
      Object.keys(query)
        .map((key) => {
          return key + '=' + query[key]
        })
        .join('&')
    console.log('小程序地址为')
    console.log(weappUrl)
    return this.httpPOST('/account/mini_program/jump_url', { path, query_dict: query }).then((res) => res.url)
  }
}
